export default "__VITE_ASSET__BKXNhawu__"